import { Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { TransparencyPage } from './pages/TransparencyPage';
import { SettingsPage } from './pages/SettingsPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { useMembership } from './hooks/useMembership';
import { ParticipantHome } from './pages/ParticipantHome';
import { AppLayout } from './components/AppLayout';
import { StatusLoading } from './components/StatusLoading';

function HomeRoute() {
  const { membership, loading } = useMembership();

  if (loading) {
    return (
      <AppLayout>
        <StatusLoading />
      </AppLayout>
    );
  }

  if (membership?.status === 'active') {
    return <ParticipantHome />;
  }

  return <HomePage />;
}

/** Root application component with routing. */
function App() {
  return (
    <Routes>
      <Route path="/" element={<HomeRoute />} />
      <Route path="/transparency" element={<TransparencyPage />} />
      <Route path="/settings" element={<SettingsPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default App;
